import Header from '@/pages/home/components/Header';
import HeroSection from '@/pages/home/components/HeroSection';
import { FaqSection, TopicsSection, CarouselSection } from '@/pages/home/components/FaqTopicsCarousel';
import { MediaSection, CardsSection, RankingSection } from '@/pages/home/components/MediaCardsRanking';
import { AppSection, AboutSection, IndexSection, ContactSection, FeaturesSection } from '@/pages/home/components/AppAboutIndexContact';
import { UpdatesSection, CommentsSection } from '@/pages/home/components/FeaturesUpdatesComments';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950 font-sans">
      <Header />
      <main>
        <HeroSection />
        <FaqSection />
        <TopicsSection />
        <CarouselSection />
        <MediaSection />
        <CardsSection />
        <RankingSection />
        <AppSection />
        <AboutSection />
        <IndexSection />
        <ContactSection />
        <FeaturesSection />
        <UpdatesSection />
        <CommentsSection />
      </main>
      <Footer />
    </div>
  );
}